// import { HttpStateLine } from 'state-line';

// import Type from './Type';
import State, { initState } from './State';

export default (state: State = initState, action: any): State => {
  let isChange = true;
  const newState = { ...state };

  switch (action.type) {
    default:
      isChange = false;
  }

  return isChange ? newState : state;
};
